import { CommonButton, TextareaM } from '@shared/ui/index.ts';
import type { TextareaMPT } from '@shared/ui/inputs/TextareaM/ui.tsx';
import * as st from './styles.module.scss';

type PT = TextareaMPT & {
  onCopy?: () => void;
};
export const RecommendModalLinkWithCopyButton = ({ onCopy, ...props }: PT) => {
  return (
    <section className={st.wrapper}>
      <TextareaM className={st.textarea} readOnly autosize autoFocus {...props} />
      <h3 className={st.title}>{'Скопируйте ссылку и отправьте любым удобным для Вас способом'}</h3>
      <CommonButton className={st.button} onClick={onCopy}>
        Скопировать ссылку
      </CommonButton>
    </section>
  );
};
